<ion-content class="ion-content">
  <div class="content-breadcrumb">
    <ul class="breadcrumb">
      <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
        <ng-container *ngIf="itemList.embedurl; else noRoute">
          <a href="javascript:void(0)" routerLink="{{ itemList.url }}">
            {{ itemList.label }}
          </a>
        </ng-container>
        <ng-template #noRoute>
          <a style="text-decoration: none;" href="javascript:void(0)">
            {{ itemList.label }}
          </a>
        </ng-template>
      </li>
    </ul>
  </div>
  <div class="listing">
    <mat-card class="listing-card">
      <mat-card-title class="mc-title">
        <span class="table-header">Marketplace Cart</span>
      </mat-card-title>
      <mat-card-content *ngIf="apicatalouge.length > 0 && loading">
        <div class="flex-container" *ngFor="let cat of apicatalouge">
          <mat-card class="main-section" style="height: 200px;margin-bottom: 10px;">
            <div class="container" style="display: flex; align-items: center; max-height: 100%; overflow: hidden;">
              <div class="side" style="max-height: 100%; overflow: hidden;" (click)="catalogDetails(cat.ID)">
                <img [src]="'data:image/jpg;base64,' + cat.image">
              </div>
          
              <div class="main" *ngIf="loading" style="max-height: 100%; overflow: hidden;" (click)="catalogDetails(cat.ID)">
                <h1>{{cat.api_description}}</h1>
                <mat-card-subtitle>
                  <span class="subtitle"> By {{cat.brand_name}} | {{cat.api_product_name}} | {{cat.category_name}}</span>
                  <span class="type">Type: {{cat.type}}</span>
                  <h3> {{cat.api_business_object}} </h3>
                  Method: {{cat.method}}
                  &nbsp;&nbsp; Price & Deal: {{cat.price_type}}
                </mat-card-subtitle>
              </div>
              <div class="status" style="max-height: 100%; overflow: hidden;">
                <span style="color: red;cursor: pointer;" (click)="deleteFromCart(cat.ID)"><mat-icon class="mat-icon">delete</mat-icon></span>
              </div>
            </div>
          </mat-card>
        </div>
      </mat-card-content>

      <mat-card-content *ngIf="apicatalouge.length === 0 && loading">
        <p class="search-result">
          No Results Found!
        </p>
        <p class="search-esle">
          Add APIs to cart
        </p>
      </mat-card-content>
    </mat-card>
  </div>
  
  <app-footer *ngIf="loading"></app-footer>
</ion-content>